import type { ReactNode } from 'react'
import type { Variants } from 'framer-motion'

import { motion } from 'framer-motion'

export const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1]

const VIEWPORT = { once: true, margin: '0px 0px -12% 0px' }

interface RevealProps {
    children: ReactNode
    className?: string
    delay?: number
    y?: number
    x?: number
}

export const Reveal = ({ children, className, delay = 0, y = 26, x = 0 }: RevealProps): ReactNode => {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y, x }}
            whileInView={{ opacity: 1, y: 0, x: 0 }}
            viewport={VIEWPORT}
            transition={{ duration: 0.75, ease: EASE_OUT, delay }}
        >
            {children}
        </motion.div>
    )
}

export const staggerParent: Variants = {
    hidden: {},
    show: {
        transition: {
            staggerChildren: 0.09,
            delayChildren: 0.05
        }
    }
}

export const fadeUpChild: Variants = {
    hidden: { opacity: 0, y: 22 },
    show: {
        opacity: 1,
        y: 0,
        transition: { duration: 0.65, ease: EASE_OUT }
    }
}

interface StaggerProps {
    children: ReactNode
    className?: string
}

export const Stagger = ({ children, className }: StaggerProps): ReactNode => {
    return (
        <motion.div
            className={className}
            variants={staggerParent}
            initial='hidden'
            whileInView='show'
            viewport={VIEWPORT}
        >
            {children}
        </motion.div>
    )
}

export const StaggerItem = ({ children, className }: StaggerProps): ReactNode => {
    return (
        <motion.div className={className} variants={fadeUpChild}>
            {children}
        </motion.div>
    )
}
